/**
 * Colour collection grid — React ColourCollection.tsx + Shopify products.
 * Packshots must match the selected cord. Never fall back to a product's
 * featured image (those default to mixed colours).
 */
(function () {
  var HOLY = { brown: 1, 'silver-grey': 1, green: 1, ivory: 1, 'navy-blue': 1, 'light-pink': 1, black: 1, red: 1 };
  var MATCHY = { black: 1, 'navy-blue': 1, bordeaux: 1, red: 1, 'silver-grey': 1, gold: 1 };
  var SPARKLE = {
    'light-blue': 1, 'light-pink': 1, gold: 1, 'silver-grey': 1, lilac: 1,
    black: 1, red: 1, ivory: 1, green: 1, orange: 1, yellow: 1, 'navy-blue': 1,
    purple: 1, brown: 1
  };

  var COLOR_ALIASES = {
    red: ['red'],
    bordeaux: ['bordeaux'],
    'dark-pink': ['dark-pink', 'old-pink'],
    'light-pink': ['light-pink', 'baby-pink', 'pink'],
    'fluo-pink': ['fluo-pink'],
    orange: ['orange'],
    gold: ['gold'],
    yellow: ['yellow'],
    'fluo-yellow': ['fluo-yellow'],
    green: ['green'],
    turquoise: ['turquoise', 'turq-blue'],
    'light-blue': ['light-blue', 'jeans-blue'],
    'navy-blue': ['navy-blue', 'navy', 'royal-blue'],
    lilac: ['lilac', 'lavendel', 'lavender'],
    purple: ['purple', 'lila'],
    brown: ['brown'],
    black: ['black'],
    'silver-grey': ['silver-grey', 'grey', 'silver'],
    white: ['white'],
    ivory: ['ivory']
  };

  var CATALOG = [
    { handles: ['cuty-bracelet'], name: 'Cuty', carat: '0.05 ct', group: 'all', kind: 'cuty' },
    { handles: ['cubix-bracelet'], name: 'Cubix', carat: '0.05 ct', group: 'all', kind: 'cubix' },
    { handles: ['holy-cross'], name: 'Holy Cross', carat: '0.50 ct', group: 'holy', kind: 'holy', symbol: 'cross' },
    { handles: ['holy-greek-cross'], name: 'Holy Greek Cross', carat: '0.50 ct', group: 'holy', kind: 'holy', symbol: 'greek-cross' },
    { handles: ['holy-davidstar'], name: 'Holy David Star', carat: '0.50 ct', group: 'holy', kind: 'holy', symbol: 'davidstar' },
    { handles: ['holy-hamsa'], name: 'Holy Hamsa', carat: '0.50 ct', group: 'holy', kind: 'holy', symbol: 'hamsa' },
    { handles: ['matchy-heart'], name: 'Matchy Heart', carat: '0.60 ct', group: 'matchy', kind: 'matchy', shape: 'heart', colors: { 'navy-blue': 1, bordeaux: 1, red: 1, 'silver-grey': 1, gold: 1 } },
    { handles: ['matchy-pear'], name: 'Matchy Pear', carat: '0.60 ct', group: 'matchy', kind: 'matchy', shape: 'pear' },
    {
      handles: ['matchy-emerald'],
      name: 'Matchy Emerald',
      carat: '0.60 ct',
      group: 'matchy',
      kind: 'matchy',
      shape: 'emerald',
      /* React shows emerald beyond the core Matchy cord set when a packshot exists */
      colors: { black: 1, 'navy-blue': 1, bordeaux: 1, red: 1, 'silver-grey': 1, gold: 1, 'dark-pink': 1, 'light-pink': 1, 'fluo-pink': 1, orange: 1, yellow: 1, 'fluo-yellow': 1, green: 1, turquoise: 1, 'light-blue': 1, lilac: 1, white: 1, ivory: 1, purple: 1, brown: 1 }
    },
    {
      handles: ['multi-three-mix'],
      name: 'Triply Mix',
      carat: '0.15 ct',
      group: 'matchy',
      kind: 'multi',
      multi: 'three-mix',
      /* React only lists Triply where detached packshots exist (not Bordeaux) */
      colors: { black: 1, 'navy-blue': 1, red: 1, 'silver-grey': 1, gold: 1 }
    },
    {
      handles: ['multi-three-white'],
      name: 'Triply White',
      carat: '0.15 ct',
      group: 'matchy',
      kind: 'multi',
      multi: 'three-white',
      colors: { black: 1, 'navy-blue': 1, red: 1, 'silver-grey': 1, gold: 1 }
    },
    {
      handles: ['multi-three-rose'],
      name: 'Triply Pink',
      carat: '0.15 ct',
      group: 'matchy',
      kind: 'multi',
      multi: 'three-rose',
      colors: { black: 1, 'navy-blue': 1, red: 1, 'silver-grey': 1, gold: 1 }
    },
    {
      handles: ['multi-three-yellow'],
      name: 'Triply Yellow',
      carat: '0.15 ct',
      group: 'matchy',
      kind: 'multi',
      multi: 'three-yellow',
      colors: { black: 1, 'navy-blue': 1, red: 1, 'silver-grey': 1, gold: 1 }
    },
    { handles: ['multi-four-white', 'multi-four-yellow', 'multi-four-rose'], name: 'Multi Four', carat: '0.20 ct', group: 'matchy', kind: 'multi', multi: 'four' },
    { handles: ['multi-five-white', 'multi-five-yellow', 'multi-five-rose'], name: 'Multi Five', carat: '0.25 ct', group: 'matchy', kind: 'multi', multi: 'five' },
    { handles: ['shapy-shine-heart'], name: 'Shapy Shine Heart', carat: '0.10 ct', group: 'all', kind: 'shine', shape: 'heart' },
    { handles: ['shapy-shine-pear'], name: 'Shapy Shine Pear', carat: '0.10 ct', group: 'all', kind: 'shine', shape: 'pear' },
    { handles: ['shapy-shine-marquise'], name: 'Shapy Shine Marquise', carat: '0.10 ct', group: 'all', kind: 'shine', shape: 'marquise' },
    { handles: ['shapy-shine-oval'], name: 'Shapy Shine Oval', carat: '0.10 ct', group: 'all', kind: 'shine', shape: 'oval' },
    { handles: ['shapy-shine-emerald'], name: 'Shapy Shine Emerald', carat: '0.10 ct', group: 'all', kind: 'shine', shape: 'emerald' },
    { handles: ['shapy-shine-longcushion', 'shapy-shine-long-cushion'], name: 'Shapy Shine Long Cushion', carat: '0.30 ct', group: 'all', kind: 'shine', shape: 'longcushion' },
    { handles: ['shapy-sparkle-round'], name: 'Shapy Sparkle Round', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'round' },
    { handles: ['shapy-sparkle-pear'], name: 'Shapy Sparkle Pear', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'pear' },
    { handles: ['shapy-sparkle-oval'], name: 'Shapy Sparkle Oval', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'oval' },
    { handles: ['shapy-sparkle-heart'], name: 'Shapy Sparkle Heart', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'heart' },
    { handles: ['shapy-sparkle-princesse', 'shapy-sparkle-princess'], name: 'Shapy Sparkle Princess', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'princess' },
    { handles: ['shapy-sparkle-cushion'], name: 'Shapy Sparkle Cushion', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'cushion' },
    { handles: ['shapy-sparkle-marquise'], name: 'Shapy Sparkle Marquise', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'marquise' },
    { handles: ['shapy-sparkle-emerald'], name: 'Shapy Sparkle Emerald', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'emerald' },
    { handles: ['shapy-sparkle-longcushion', 'shapy-sparkle-long-cushion'], name: 'Shapy Sparkle Long Cushion', carat: '0.70 ct', group: 'sparkle', kind: 'sparkle', shape: 'longcushion' }
  ];

  var shapyMapPromise = null;
  var shapyMapLoadedUrl = '';

  function parseJson(el, fallback) {
    try {
      return JSON.parse(el && el.textContent ? el.textContent : '');
    } catch (e) {
      return fallback;
    }
  }

  function slugFromPath() {
    var params = new URLSearchParams(window.location.search || '');
    var fromQuery = (params.get('color') || params.get('colour') || '').toLowerCase();
    if (fromQuery) return fromQuery;
    var path = (window.location.pathname || '').replace(/\/$/, '').toLowerCase();
    path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '') || '/';
    var m = path.match(/\/(?:pages\/)?colou?rs\/([a-z0-9-]+)$/);
    return m ? m[1] : '';
  }

  function allowed(item, color) {
    if (item.colors) return !!item.colors[color];
    if (item.group === 'all') return true;
    if (item.group === 'holy') return !!HOLY[color];
    if (item.group === 'matchy') return !!MATCHY[color];
    if (item.group === 'sparkle') return !!SPARKLE[color];
    return false;
  }

  function findShop(handles, shopMap) {
    for (var i = 0; i < handles.length; i++) {
      if (shopMap[handles[i]]) return shopMap[handles[i]];
    }
    return null;
  }

  function aliases(color) {
    return COLOR_ALIASES[color] || [color];
  }

  /** Theme-serve preview uses 127.0.0.1 but Liquid asset_url points at the remote CDN. */
  function previewAssetUrl(url) {
    if (!url) return url;
    try {
      var parsed = new URL(url, window.location.href);
      if (/^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname)) {
        parsed.protocol = window.location.protocol;
        parsed.host = window.location.host;
      }
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  function fileUrl(sample, filename) {
    if (!sample || !filename) return '';
    try {
      var url = new URL(sample, window.location.href);
      var parts = url.pathname.split('/');
      parts[parts.length - 1] = filename;
      url.pathname = parts.join('/');
      url.search = '';
      return previewAssetUrl(url.toString());
    } catch (e) {
      return sample.replace(/[^/]+\.(webp|png|jpe?g)(\?.*)?$/i, filename);
    }
  }

  function withExt(bases) {
    var out = [];
    var seen = {};
    bases.forEach(function (base) {
      // Prefer png first — most multi/matchy packshots are png-only
      ['png', 'webp', 'jpeg', 'jpg'].forEach(function (ext) {
        var name = base + '.' + ext;
        if (!seen[name]) {
          seen[name] = 1;
          out.push(name);
        }
      });
    });
    return out;
  }

  function packshotFiles(item, color) {
    var alts = aliases(color);
    var bases = [];
    if (item.kind === 'cuty') {
      alts.forEach(function (a) {
        bases.push('cuty-yellow-' + a, 'cuty-white-' + a);
      });
    } else if (item.kind === 'cubix') {
      alts.forEach(function (a) {
        bases.push('cubix-white-' + a, 'cubix-yellow-' + a);
      });
    } else if (item.kind === 'holy') {
      alts.forEach(function (a) {
        bases.push('holy-' + item.symbol + '-yellow-' + a, 'holy-' + item.symbol + '-white-' + a);
      });
    } else if (item.kind === 'matchy') {
      alts.forEach(function (a) {
        bases.push(
          'matchy-' + item.shape + '-bezel-white-white-' + a,
          'matchy-' + item.shape + '-bezel-white-' + a
        );
      });
    } else if (item.kind === 'multi') {
      if (item.multi === 'three-mix') {
        alts.forEach(function (a) {
          bases.push('multi-three-mix-' + a, 'multi-three-mix-attached-' + a);
        });
      } else if (item.multi === 'three-white') {
        alts.forEach(function (a) {
          bases.push('multi-three-white-' + a, 'multi-three-white-attached-' + a);
        });
      } else if (item.multi === 'three-rose') {
        alts.forEach(function (a) {
          bases.push('multi-three-rose-' + a, 'multi-three-rose-attached-' + a);
        });
      } else if (item.multi === 'three-yellow') {
        alts.forEach(function (a) {
          bases.push('multi-three-yellow-' + a, 'multi-three-yellow-attached-' + a);
        });
      } else if (item.multi === 'four') {
        alts.forEach(function (a) {
          bases.push('multi-four-white-' + a, 'multi-four-yellow-' + a, 'multi-four-' + a);
        });
      } else if (item.multi === 'five') {
        alts.forEach(function (a) {
          bases.push('multi-five-yellow-' + a, 'multi-five-white-' + a, 'multi-five-' + a);
        });
      }
    }
    return withExt(bases);
  }

  var MULTI_WORD_CORDS = {
    'dark-pink': 1, 'light-pink': 1, 'fluo-pink': 1, 'fluo-yellow': 1,
    'light-blue': 1, 'navy-blue': 1, 'silver-grey': 1, 'yellow-gold': 1,
    'turq-blue': 1, 'baby-pink': 1, 'old-pink': 1, 'olive-green': 1,
    'mint-green': 1, 'royal-blue': 1, 'jeans-blue': 1
  };

  var CORD_CANON = {
    // Note: do NOT map yellow-gold → gold (yellow-gold is metal, gold is a cord)
    grey: 'silver-grey',
    silver: 'silver-grey',
    'baby-pink': 'light-pink',
    'old-pink': 'dark-pink',
    navy: 'navy-blue',
    'royal-blue': 'navy-blue',
    'turq-blue': 'turquoise',
    lavendel: 'lilac',
    lavender: 'lilac',
    lila: 'lilac'
  };

  function shapyCordSlug(filename) {
    var n = String(filename || '').toLowerCase().replace(/_/g, '-');
    var m = n.match(/^(.*)-(white|yellow)-gold(?:-|\.|$)/);
    if (!m) return '';
    var bits = m[1].split('-').filter(Boolean);
    if (!bits.length) return '';
    var last = bits[bits.length - 1];
    var prev = bits.length > 1 ? bits[bits.length - 2] + '-' + last : '';
    return prev && MULTI_WORD_CORDS[prev] ? prev : last;
  }

  function shapyMatchesColor(filename, color) {
    var raw = shapyCordSlug(filename);
    if (!raw) return false;
    var cord = CORD_CANON[raw] || raw;
    if (cord === color) return true;
    return aliases(color).indexOf(cord) !== -1 || aliases(color).indexOf(raw) !== -1;
  }

  function shapeNeedles(shape) {
    if (shape === 'longcushion') return ['longcushion', 'long-cushion', 'long_cushion', 'long cushion'];
    if (shape === 'princess') return ['princess', 'princesse'];
    return [shape];
  }

  function isLongCushionPath(path) {
    return /long[-_ ]?cushion|longcushion/.test(path || '');
  }

  function pickShapyFiles(map, item, color) {
    if (!map) return [];
    var list = item.kind === 'sparkle' ? (map.sparkle || []) : (map.shine || []);
    var needles = shapeNeedles(item.shape);
    var ranked = [];
    list.forEach(function (entry) {
      var flat = String(entry.flattened || '');
      var original = String(entry.original || '');
      var path = (flat + ' ' + original).toLowerCase();
      if (path.indexOf('necklace') !== -1) return;
      // Plain cushion must not match long-cushion filenames
      if (item.shape === 'cushion' && isLongCushionPath(path)) return;
      var hasShape = needles.some(function (s) { return path.indexOf(s) !== -1; });
      if (!hasShape) return;
      var hasColor = shapyMatchesColor(flat, color) || shapyMatchesColor(original.split('/').pop() || '', color);
      if (!hasColor) return;
      var rawCord = shapyCordSlug(flat);
      var cord = CORD_CANON[rawCord] || rawCord;
      var score = 0;
      if (item.kind === 'shine' && (/(^|[-_])wg([-_]|$)/.test(path) || /white[-_]gold/.test(path))) score += 3;
      if (item.kind === 'sparkle' && (/(^|[-_])wg([-_]|$)/.test(path) || /white[-_]gold/.test(path))) score += 2;
      if (/bezel/.test(path)) score += 1;
      if (/_2\.(png|webp|jpe?g)$/i.test(flat)) score -= 2;
      if (/\.webp$/i.test(flat)) score += 1;
      if (cord === color) score += 1;
      if (color === 'light-blue' && (cord === 'jeans-blue' || rawCord === 'jeans-blue')) score += 8;
      if (color === 'navy-blue' && (cord === 'royal-blue' || rawCord === 'royal-blue')) score += 2;
      var file = flat.split('/').pop() || original.split('/').pop() || '';
      if (file) ranked.push({ file: file, score: score });
    });
    ranked.sort(function (a, b) { return b.score - a.score; });
    var out = [];
    var seen = {};
    ranked.forEach(function (row) {
      if (seen[row.file]) return;
      seen[row.file] = 1;
      out.push(row.file);
    });
    return out;
  }

  function pickShapyFile(map, item, color) {
    var files = pickShapyFiles(map, item, color);
    return files[0] || '';
  }

  function loadShapyMap(url) {
    url = previewAssetUrl(url || '');
    if (!url) return Promise.resolve(null);
    if (!shapyMapPromise || shapyMapLoadedUrl !== url) {
      shapyMapLoadedUrl = url;
      shapyMapPromise = fetch(url)
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    }
    return shapyMapPromise;
  }

  function bindFallbacks(img, urls, tile) {
    if (!img || !urls.length) return;
    var rest = urls.slice(1);
    img.addEventListener('error', function onErr() {
      if (!rest.length) {
        img.removeEventListener('error', onErr);
        if (tile) tile.style.display = 'none';
        else img.style.display = 'none';
        return;
      }
      img.src = rest.shift();
    });
  }

  /** Resolve first packshot URL that actually loads (React only lists products with images). */
  function firstExistingUrl(urls) {
    return new Promise(function (resolve) {
      var i = 0;
      function next() {
        if (i >= urls.length) {
          resolve('');
          return;
        }
        var url = urls[i++];
        if (!url) {
          next();
          return;
        }
        var img = new Image();
        img.onload = function () { resolve(url); };
        img.onerror = next;
        img.src = url;
      }
      next();
    });
  }

  function formatCount(i18n, n) {
    return String(i18n.count || '__COUNT__ products available')
      .replace('__COUNT__', String(n))
      .replace('{{ count }}', String(n));
  }

  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    var color = slugFromPath();
    var meta = parseJson(root.querySelector('[data-ll-colour-meta]'), {});
    var info = meta[color];
    if (!color || !info) return;
    root.dataset.ready = '1';

    var shopList = parseJson(root.querySelector('[data-ll-shop-products]'), []);
    var shopMap = {};
    (shopList || []).forEach(function (p) {
      if (p && p.handle) shopMap[p.handle] = p;
    });
    var assets = parseJson(root.querySelector('[data-ll-colour-assets]'), {});
    var i18n = parseJson(root.querySelector('[data-ll-colour-i18n]'), {});
    var sample = assets.sample || '';

    var crumb = root.querySelector('[data-ll-cc-crumb]');
    var title = root.querySelector('[data-ll-cc-title]');
    var meaning = root.querySelector('[data-ll-cc-meaning]');
    var desc = root.querySelector('[data-ll-cc-desc]');
    var countEl = root.querySelector('[data-ll-cc-count]');
    var swatch = root.querySelector('[data-ll-cc-swatch]');
    var grid = root.querySelector('[data-ll-cc-grid]');

    if (crumb) crumb.textContent = info.name;
    if (title) title.textContent = info.name;
    if (meaning) meaning.textContent = info.meaning;
    if (desc) desc.textContent = info.description;
    document.title = (i18n.pageTitle || '{{ color }} Bracelets | {{ color }} Cord Collection | LoveLab Antwerp').replace(/\{\{\s*color\s*\}\}/g, info.name);

    function tileAlt(name) {
      return (i18n.tileAlt || '{{ name }} bracelet with {{ color }} cord')
        .replace(/\{\{\s*name\s*\}\}/g, name)
        .replace(/\{\{\s*color\s*\}\}/g, info.name);
    }

    if (swatch) {
      swatch.style.backgroundColor = info.hex;
      swatch.style.boxShadow = (info.hex === '#FFFFFF' || info.hex === '#FCF8ED')
        ? 'inset 0 0 0 1px rgba(0,0,0,0.1), 0 8px 24px ' + info.hex + '40'
        : '0 8px 24px ' + info.hex + '40';
    }

    root.querySelectorAll('[data-ll-cc-dot]').forEach(function (dot) {
      dot.classList.toggle('is-active', dot.getAttribute('data-ll-cc-dot') === color);
    });

    loadShapyMap(assets.shapyMap).then(function (shapyMap) {
      var jobs = CATALOG.map(function (item) {
        if (!allowed(item, color)) return Promise.resolve(null);
        var shop = findShop(item.handles, shopMap);
        if (!shop || !shop.url) return Promise.resolve(null);

        if (item.kind === 'shine' || item.kind === 'sparkle') {
          var shapyCandidates = pickShapyFiles(shapyMap, item, color).map(function (name) {
            return fileUrl(sample, name);
          }).filter(Boolean);
          return firstExistingUrl(shapyCandidates).then(function (okUrl) {
            if (!okUrl) return null;
            return {
              url: shop.url,
              name: item.name,
              carat: item.carat,
              price: shop.price,
              urls: [okUrl].concat(shapyCandidates.filter(function (u) { return u !== okUrl; })),
              alt: tileAlt(item.name)
            };
          });
        }

        var candidates = packshotFiles(item, color).map(function (name) {
          return fileUrl(sample, name);
        }).filter(Boolean);

        return firstExistingUrl(candidates).then(function (okUrl) {
          if (!okUrl) return null;
          return {
            url: shop.url,
            name: item.name,
            carat: item.carat,
            price: shop.price,
            urls: [okUrl].concat(candidates.filter(function (u) { return u !== okUrl; })),
            alt: tileAlt(item.name)
          };
        });
      });

      return Promise.all(jobs).then(function (results) {
        var cards = results.filter(Boolean);

        if (countEl) countEl.textContent = formatCount(i18n, cards.length);

        if (!grid) return;
        grid.innerHTML = '';
        cards.forEach(function (card) {
          var a = document.createElement('a');
          a.className = 'll-colour-tile';
          a.href = card.url;
          var imgHtml = card.urls[0]
            ? '<img src="' + card.urls[0] + '" alt="' + card.alt.replace(/"/g, '') + '" loading="lazy">'
            : '';
          a.innerHTML =
            '<div class="ll-colour-tile__media">' + imgHtml + '</div>' +
            '<h3>' + card.name + '</h3>' +
            (card.carat ? '<p class="ll-colour-tile__carat">' + card.carat + '</p>' : '') +
            '<p class="ll-colour-tile__price">' + (i18n.from || 'From') + ' ' + (card.price || '') + '</p>';
          bindFallbacks(a.querySelector('img'), card.urls, a);
          grid.appendChild(a);
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ll-colour-collection]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
